import { ITEM_TYPE } from '@beef/shop-common';

import {
  CONTENT_TAB_ABOUT,
  CONTENT_TAB_FEEDBACK,
  CONTENT_TAB_DELIVERY,
  CONTENT_TAB_PAYMENT,
  CONTENT_TAB_SERVICES,
  CONTENT_TAB_CROSS_SALE,
} from 'store/ProductDetails/constants';

import { commonClickEvent, remainsNumToText, sectionToGTMPosition } from './helpers';
import { positionGTMEnum } from './constants';
import * as types from './eventTypes';

const sectionSlugToGtm = {
  [CONTENT_TAB_ABOUT]: 'characteristics',
  [CONTENT_TAB_FEEDBACK]: 'feedbacks',
  [CONTENT_TAB_DELIVERY]: 'deliveryAndPickup',
  [CONTENT_TAB_PAYMENT]: 'paymentAndCredit',
  [CONTENT_TAB_SERVICES]: 'productDetailsServicesAccess',
};

export default function pushToGTM(type, data) {
  let dataLayer = [];
  if (typeof window !== 'undefined') ({ dataLayer } = window);
  let defined = true;
  if (!dataLayer) {
    defined = false;
    dataLayer = [];
  }

  try {
    switch (type) {
      case types.EVENT_FEEDBACK_SUCCESS:
        dataLayer.push({
          event: 'BigEvent',
          eventAction: 'SendSuccess',
          eventCategory: 'Forms',
          eventLabel: 'ShopItemComment',
          eventContext: `${data.rating}`,
        });
        break;
      case types.EVENT_CATALOG_LOAD:
        /**
         * load event happens once, when catalog is loaded
         */

        break;
      case types.EVENT_NOTIFY_POPUP_OPEN: {
        dataLayer.push({
          event: 'popupOpen_Bee',
        });
        break;
      }
      case types.EVENT_NOTIFY_POPUP_FILLED: {
        dataLayer.push({
          event: 'popupTypein_Bee',
        });
        break;
      }
      case types.EVENT_NOTIFY_POPUP_SUBSCRIBED: {
        dataLayer.push({
          event: 'popupSend_Bee',
        });
        break;
      }
      case types.EVENT_NOTIFY_POPUP_CLOSED: {
        dataLayer.push({
          event: 'popupClose_Bee',
        });
        break;
      }
      case types.EVENT_CATALOG_UPDATE: {
        /**
         * update is called every time catalog products change, initially and after filter change
         */
        dataLayer.push({
          event: 'catalog_EC',
          regionName: data.regionName,
          federalRegionName: data.federalRegionName,
          ecommerce: {
            currencyCode: 'RUB',
            impressions: data.impressions,
          },
        });
        break;
      }
      case types.EVENT_CATALOG_TOGGLE_FILTER: {
        if (data.isActive) {
          dataLayer.push({
            event: 'useFilter_Bee',
            details: {
              section: data.section,
              choice: data.choice,
            },
          });
        }
        break;
      }
      case types.EVENT_CATALOG_SHOW_MORE_FILTER: {
        dataLayer.push({
          event: 'showMoreFilter_Bee',
          details: {
            section: data.section,
          },
        });
        break;
      }
      case types.EVENT_CATALOG_PRICE_FILTER: {
        dataLayer.push({
          event: 'useFilter_Bee',
          details: {
            section: 'Цена',
            choice: 'Изменена',
          },
        });
        break;
      }
      case types.SCROLL_TOP_BTN_CLICK: {
        dataLayer.push({
          event: 'upwards_Bee',
          details: {
            flow: 'Наверх',
          },
        });
        break;
      }
      case types.EVENT_COMMON_SWITCH_TO_CARD:
      case types.EVENT_OPEN_ACCESSORY_POPUP: {
        const {
          list,
          brand,
          category,
          id,
          name,
          price,
          position,
          isTariff,
          dimension15 = null,
          dimension16 = null,
          dimension17 = null,
          metric14 = 0,
          metric15 = null,
        } = data;

        dataLayer.push({
          event: 'productClick_EC',
          ecommerce: {
            currencyCode: 'RUB', // Валюта
            click: {
              actionField: { list },
              products: [
                {
                  brand,
                  category,
                  id,
                  name,
                  position: position ? `${position}` : '',
                  price: price ? `${price}` : '',
                  metric14,
                  metric15,
                  dimension15,
                  ...(isTariff ? null : (
                    {
                      dimension16,
                    }
                  )),
                  dimension17,
                },
              ],
            },
          },
        });
        break;
      }
      case types.EVENT_COMMON_ADD_TO_CART: {
        // из каталога
        const {
          /* Пока не удаляем закомментированный код */
          /* list,
          brand,
          category,
          id,
          name,
          price,
          position,
          isTariff,
          dimension15 = null,
          dimension16 = null,
          dimension17 = null,
          metric14 = 0,
          metric15 = null, */
          variant,
        } = data;

        // new
        dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              products: [
                {
                  id: data.article,
                  name: data.name,
                  price: `${data.price}`,
                  brand: data.brand,
                  // было "Телефоны/Смартфоны", = через "/" значения атрибутов "mainCollectionName"
                  // и "subCollectionName",
                  // стало только реальный mainCollectionName
                  category: data?.collectionName?.toLowerCase(),
                  variant,
                  quantity: 1,
                },
              ],
            },
          },
        });
        // old

        /* Пока не удаляем закомментированный код */
        /*
        dataLayer.push({
          event: 'addToCart_EC',
          ecommerce: {
            currencyCode: 'RUB', // Валюта
            add: {
              actionField: { list },
              products: [
                {
                  brand,
                  category,
                  id,
                  name,
                  position: position ? `${position}` : '',
                  price: price ? `${price}` : '',
                  metric14,
                  metric15,
                  dimension15,
                  ...(isTariff
                    ? null
                    : {
                      dimension16,
                      quantity: 1,
                    }),
                  dimension17,
                },
              ],
            },
          },
        });
        */
        break;
      }
      case types.EVENT_CATALOG_CHANGE_VIEW:
        dataLayer.push({
          event: 'Sorting Class',
          sorting_class: data.type,
        });
        break;
      case types.EVENT_CATALOG_VIEW_PROMO_BANNER:
        dataLayer.push({
          event: 'promoView_EC',
          ecommerce: {
            promoView: {
              promotions: [{ markup: data }],
            },
          },
        });
        break;
      case types.EVENT_CATALOG_CLICK_PROMO_BANNER:
        dataLayer.push({
          event: 'promoClick_EC',
          ecommerce: {
            promoView: {
              promotions: [{ markup: data }],
            },
          },
        });
        break;
      case types.EVENT_CARD_VIEW_PROMO_BANNER:
        dataLayer.push({
          event: 'promoView_EC',
          ecommerce: {
            promoView: {
              promotions: [{ markup: data }],
            },
          },
        });
        break;
      case types.EVENT_CARD_CLICK_PROMO_BANNER:
        dataLayer.push({
          event: 'promoClick_EC',
          ecommerce: {
            promoView: {
              promotions: [{ markup: data }],
            },
          },
        });
        break;
      case types.EVENT_ADD_TO_CART: {
        // из карточки
        // new
        /* let curCategory = '';
        if (data?.collectionName && data?.subCollectionName) {
          curCategory = `${data.collectionName}/${data.subCollectionName}`;
        } */
        dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              products: [
                {
                  id: data.article, // data.productId,
                  name: data.name,
                  price: `${data.price}`,
                  brand: data.brand,
                  // "Телефоны/Смартфоны", = через "/" значения атрибутов "mainCollectionName" и "subCollectionName",
                  category: data?.categoryYM?.toLowerCase(), // curCategory,
                  variant: data?.variant,
                  quantity: 1,
                },
              ],
            },
          },
        });

        if (data?.itemType === ITEM_TYPE.SERVICE) {
          dataLayer.push({
            event: 'BigEvent',
            eventCategory: 'Interactions',
            eventAction: 'Switch',
            eventLabel: 'ShopItemInfo',
            eventContext: 'insurance',
          });
        }
        // old
        /* Пока не удаляем закомментированный код */
        /*
        dataLayer.push({
          event: 'addToCart_EC',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              actionField: { list: data.clickSection },
              products: [
                {
                  brand: data.brand,
                  category: data.category,
                  id: data.productId,
                  name: data.name,
                  price: `${data.price}`,
                  metric14: data.discount,
                  metric15: data.rating || '',
                  dimension15: data.highLights,
                  dimension17: data.contentPromotion,
                  ...(data.isTariff
                    ? null
                    : {
                      dimension16: remainsNumToText(data.productRemains),
                      quantity: 1,
                    }),
                },
              ],
            },
          },
        });

        dataLayer.push({
          ...commonClickEvent,
          eventCategory: 'ecommerceClick',
          eventAction: 'Добавление товара в корзину',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              products: [
                {
                  name: data.name,
                  id: `${data.productId}`,
                  price: `${data.price}`,
                  brand: data.brand,
                  category: data.category,
                  variant: '',
                  quantity: 1,
                },
              ],
            },
          },
        });
        */
        break;
      }
      case types.EVENT_CLICK_BUTTON_PICKUPBUY:
        dataLayer.push({
          event: 'checkout_EC',
          purchaseMethod: 1,
          viewMethod: 'Метро', // default view
          ecommerce: {
            checkout: {
              actionField: { step: 1 },
              products: [
                {
                  brand: data.brandName,
                  category: data?.mainCollectionName?.toLowerCase(),
                  id: data.id,
                  name: data.name,
                  price: data.price ? `${data.price}` : '',
                  metric14: data.discount,
                  metric15: data.rating,
                  dimension15: data.highLights,
                  dimension17: data.contentPromotion,
                  quantity: 1,
                },
              ],
            },
          },
        });
        dataLayer.push({
          ...commonClickEvent,
          eventAction: 'Забрать в салоне',
          eventCategory: 'openTab',
        });
        break;
      case types.EVENT_OPEN_BALLOON_PICKUPBUY:
        dataLayer.push({
          ...commonClickEvent,
          eventAction: 'Выбор магазина / bubble',
        });
        break;
      case types.EVENT_CLOSE_BALLOON_PICKUPBUY:
        dataLayer.push({
          ...commonClickEvent,
          eventAction: 'Close Tab / b',
        });
        break;
      case types.EVENT_OPEN_POPUP_PICKUPBUY: {
        const { pointGTMType, point } = data;
        dataLayer.push({
          event: 'checkoutOption_EC',
          purchaseMethod: 1,
          viewMethod: pointGTMType,
          ecommerce: {
            checkout_option: {
              actionField: {
                step: 1,
                option: (point || {}).pointCode,
              },
            },
          },
        });
        dataLayer.push({
          ...commonClickEvent,
          eventAction: 'Забрать здесь / button',
        });
        break;
      }
      case types.EVENT_OPEN_FORM_PICKUPBUY: {
        dataLayer.push({
          event: 'checkout_EC',
          purchaseMethod: 1,
          ecommerce: {
            checkout: {
              actionField: { step: 2 },
            },
          },
        });
        break;
      }
      case types.EVENT_CLOSE_POPUP_PICKUPBUY: {
        const { viewState } = data;
        if (viewState === 'form') {
          dataLayer.push({
            ...commonClickEvent,
            eventAction: 'Close Form / b',
          });
        } else if (viewState === 'success') {
          dataLayer.push({
            ...commonClickEvent,
            eventAction: 'Close Form Conf / b',
          });
        }
        break;
      }
      case types.EVENT_BLUR_SEARCH_PICKUPBUY:
        dataLayer.push({
          ...commonClickEvent,
          eventAction: data.query,
          eventCategory: 'Search',
        });
        break;
      case types.EVENT_CONTACT_FILLED_PICKUPBUY:
        dataLayer.push({
          event: 'input_Bee',
          purchaseMethod: 1,
          details: {
            flow: 'Оформление заказа',
            name: data.fieldData,
          },
        });
        dataLayer.push({
          ...commonClickEvent,
          eventAction: data.fieldData,
          eventCategory: 'YOUR_CONTACTS',
        });
        break;
      case types.EVENT_PREORDER_REQUEST: {
        if (!data.serverErrors && !data.errors) {
          dataLayer.push({
            event: 'preorder_EC',
            eventAction: 'SendSuccess',
            ecommerce:
              data.orderId ?
                {
                  purchase: {
                    actionField: {
                      id: data.orderId, // Идентификатор заказа
                      affiliation: 'Интернет магазин',
                      revenue: data.price,
                      list: data.categoriesList, // 'Телефоны|Смартфоны',
                    },
                    products: [
                      {
                        id: data.id,
                        name: data.name,
                        category: data.categoryName,
                        brand: data.brandName,
                        price: `${data.price}`,
                        quantity: 1,
                        metric14: data.discount,
                        metric15: data.rating || 0,
                        dimension15: 'Предзаказ',
                        dimension16: remainsNumToText(data.productRemains),
                        dimension17: data.contentPromotion,
                      },
                    ],
                  },
                }
              : null,
          });
        } else if (data.serverErrors || data.errors) {
          dataLayer.push({
            event: 'error_Bee',
            details: {
              flow: 'Предзаказ',
              type: (data.serverErrors && 'ServerError') || (data.errors && 'ValidationError'),
              text: data.serverErrors || data.errors || null,
            },
          });
        }
        break;
      }
      case types.EVENT_CLICK_BUNDLE_BUY:
        dataLayer.push({
          ...commonClickEvent,
          eventAction: 'Купить в комплекте/ button',
        });
        break;
      case types.EVENT_SWITCH_TAB: {
        const { section } = data;
        if (section === CONTENT_TAB_CROSS_SALE) {
          const { regionName, federalRegionName, list, categoryName } = data;
          const impressions = list.map(
            ({ brand, productId, title, price: { value }, remains }) => ({
              brand,
              category: categoryName,
              id: productId,
              list: sectionToGTMPosition(section), // название блока в котором был показан товар
              name: title,
              price: `${value}`,
              dimension16: remainsNumToText(remains),
            }),
          );
          dataLayer.push({
            event: 'upsale_EC',
            regionName,
            federalRegionName,
            ecommerce: {
              currencyCode: 'RUB',
              impressions,
            },
          });
        }
        dataLayer.push({
          event: 'BigEvent',
          eventCategory: 'Interactions',
          eventAction: 'Switch',
          eventLabel: 'ShopItemInfo',
          eventContext: sectionSlugToGtm[data.section] || 'promoContent',
        });
        break;
      }
      case types.EVENT_VIEW_ACCESSORY: {
        const list = Array.isArray(data.list) ? data.list : [];
        const impressions = list.map((item, index) => ({
          name: item.title,
          id: item.productId,
          price: item.price ? `${item.price.value}` : '',
          brand: item.brand,
          category: data?.category,
          list: item.category,
          position: index,
          dimension16: remainsNumToText(item.remains),
        }));
        dataLayer.push({
          event: 'upsale_EC',
          regionName: data.regionName,
          federalRegionName: data.federalRegionName,
          ecommerce: {
            currencyCode: 'RUB', // Валюта
            impressions,
          },
        });
        break;
      }
      case types.EVENT_ADD_ACCESSORY:
        dataLayer.push({
          event: 'addToCart_EC',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              actionField: { list: data.list },
              products: [
                {
                  brand: data.brand,
                  category: data.category?.toLowerCase(),
                  id: data.id,
                  name: data.name,
                  price: `${data.price}`,
                  metric14: data.discount,
                  metric15: data.rating,
                  dimension15: data.highLights,
                  dimension16: remainsNumToText(data.remains),
                  dimension17: data.contentPromotion,
                  quantity: 1,
                },
              ],
            },
          },
        });

        dataLayer.push({
          event: 'BigEvent',
          eventCategory: 'Interactions',
          eventAction: 'Click',
          eventLabel: 'Accessory2Cart',
          eventContext: '',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              products: [
                {
                  name: data.name,
                  id: data.id,
                  price: `${data.price}`,
                  brand: data.brand,
                  category: data.category?.toLowerCase(),
                  variant: '',
                  quantity: 1,
                },
              ],
            },
          },
        });
        break;
      case types.EVENT_VIEW_RECENTLY: {
        const list = Array.isArray(data.list) ? data.list : [];
        let creative = '';
        list.forEach((item, index) => {
          if (index === 0) {
            creative = `${item.productId}`;
          } else {
            creative += `_${item.productId}`;
          }
        });
        dataLayer.push({
          event: 'banner_EC',
          ecommerce: {
            promoView: {
              promotions: [
                {
                  id: 'default',
                  name: positionGTMEnum.WIDGET_RECENTLY_VIEWED,
                  creative,
                  position: 'Внизу',
                },
              ],
            },
          },
        });
        break;
      }
      case types.EVENT_VIEW_RECENTLY_VIEWED: {
        const list = Array.isArray(data.list) ? data.list : [];
        const impressions = list.map((item, index) => ({
          name: item.title,
          id: item.productId,
          price: item.price ? `${item.price.value}` : '',
          brand: item.brand,
          category: data?.category,
          list: positionGTMEnum.WIDGET_RECENTLY_VIEWED,
          ...(item.isTariff ? null : (
            {
              position: index,
              dimension16: remainsNumToText(item.remains),
            }
          )),
        }));
        dataLayer.push({
          event: 'upsale_EC',
          regionName: data.regionName,
          federalRegionName: data.federalRegionName,
          ecommerce: {
            currencyCode: 'RUB', // Валюта
            impressions,
          },
        });
        break;
      }
      case types.EVENT_VIEW_RECENTLY_SWITCHED: {
        const list = Array.isArray(data.list) ? data.list : [];
        const impressions = list
          .filter((item, index) => index === data.newShownProductIndex)
          .map((item, index) => ({
            name: item.title,
            id: item.productId,
            price: item.price ? `${item.price.value}` : '',
            brand: item.brand,
            category: data?.category,
            list: positionGTMEnum.WIDGET_RECENTLY_VIEWED,
            ...(item.isTariff ? null : (
              {
                position: index,
                dimension16: remainsNumToText(item.remains),
              }
            )),
          }));
        dataLayer.push({
          event: 'upsale_EC',
          regionName: data.regionName,
          federalRegionName: data.federalRegionName,
          ecommerce: {
            currencyCode: 'RUB', // Валюта
            impressions,
          },
        });
        break;
      }
      case types.EVENT_ADD_RECENTLY_VIEWED:
        dataLayer.push({
          event: 'BigEvent',
          eventCategory: 'Interactions',
          eventAction: 'Click',
          eventLabel: 'RecentlyViewed2Cart',
          eventContext: '',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              products: [
                {
                  name: data.title,
                  id: data.productId,
                  price: data.price.value,
                  brand: data.brand,
                  category: data.category,
                  variant: '',
                  quantity: 1,
                },
              ],
            },
          },
        });
        break;
      case types.EVENT_LOAD_DETAILS:
        /** Push parameters on page load */
        dataLayer.push({
          category: data.category,
          itemSKU: `${data.id}`,
          siteType: data.isMobile ? 'm' : 'd',
        });
        /* Пока не удаляем закомментированный код */
        /*
        dataLayer.push({
          event: 'detail_EC',
          ecommerce: {
            detail: {
              products: [
                {
                  brand: data.brandName,
                  category: data.mainCollectionId,
                  id: data.id,
                  name: data.name,
                  price: data.price ? `${data.price}` : '',
                  list: data.list || '',
                  metric14: data.discount,
                  metric15: data.rating || '',
                  dimension15: data.highLights,
                  ...(data.isTariff
                    ? null
                    : {
                      dimension16: remainsNumToText(data.remains),
                    }),
                  dimension17: data.contentPromotion || null,
                },
              ],
            },
          },
        });
        dataLayer.push({
          C1: 'B2C',
          C2: 'Магазин',
          C2id: 'shop',
          C3: null,
          C3id: data.subCollectionSlug,
          C4: null,
          C4id: data.mainCollectionSlug,
          C5: null,
          C5id: null,
          ItemNumInCart: 0,
          adaptive: data.isMobile ? 'yes' : 'no',
          pageVersion: 'react',
          ecommerce: {
            currencyCode: 'RUB',
            detail: {
              products: [
                {
                  brand: data.brandName,
                  category: data.mainCollectionId,
                  id: data.id,
                  name: data.name,
                  price: data.price,
                  variant: '',
                },
              ],
            },
          },
          itemBrand: data.brandName,
          itemCategory: data.mainCollectionId,
          itemId: data.id,
          itemName: data.name,
          itemPrice: data.price,
          itemVariant: '',
          language: 'ru-RU',
          pageType: 'ShopItem',
          regionId: data.regionId,
          regionName: data.regionTitle,
          releaseNum: '0.0.0.0',
        });
        */

        break;
      case types.EVENT_CLICK_BUY_SALE:
        dataLayer.push({
          event: 'addToCart_EC',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              actionField: { list: data.clickSection },
              products: [
                {
                  brand: data.brandName,
                  category: data?.category,
                  id: data.id,
                  name: data.name,
                  price: data.price ? `${data.price}` : '',
                  metric14: data.discount,
                  dimension15: data.highLights,
                  dimension17: data.contentPromotion || null,
                  dimension16: remainsNumToText(data.remains),
                  quantity: 1,
                },
              ],
            },
          },
        });

        break;
      case types.EVENT_SUCCESS_SALE_BUY:
        dataLayer.push({
          event: 'purchase_EC',
          purchaseMethod: 0,
          ecommerce: {
            currencyCode: 'RUB',
            coupon: '',
            purchase: {
              actionField: {
                affiliation: 'Интернет магазин',
                id: data.orderId, // Номер заказа
                revenue: data.price, // Сумма заказа
                list: 'Корзина', // Раздел
              },
              products: [
                {
                  brand: data.brandName,
                  category: data?.category,
                  id: data.id,
                  name: data.name,
                  price: data.price ? `${data.price}` : '',
                  metric14: data.discount,
                  dimension15: data.highLights,
                  dimension17: data.contentPromotion || null,
                  quantity: 1,
                },
              ],
            },
          },
        });
        break;
      case types.EVENT_SUCCESS_PICKUP_BUY:
        dataLayer.push({
          event: 'orderPickUp_EC',
          purchaseMethod: 1,
          deliveryType: data.deliveryType,
          pickUpType: data.pickUpType,
          paymentType: data.paymentType,
          pickUpPartner: data.pickUpPartner,
          ecommerce: {
            currencyCode: 'RUB',
            purchase: {
              actionField: {
                affiliation: 'Интернет магазин',
                id: data.orderId,
                revenue: parseInt(data.price, 10),
                list: data.pickupSection,
                shipping: data.shipping,
              },
              products: [data.product],
            },
          },
        });

        dataLayer.push({
          urlAddress: '/virtual/funnel/shopcheckout/done/pickup',
          event: 'OrderPickUp_Bee',
          pageType: 'ShopThankYou',
          C3: 'Спасибо за заказ',
          C3id: 'purchase',
          ShopOrder: {
            id: data.orderId,
            shipping: 'monobrand_pickup',
            payment: '',
            office: data.office,
            done: '1',
            revenue: parseInt(data.price, 10),
          },
          ecommerce: {
            currencyCode: 'RUB',
            purchase: {
              actionField: {
                id: data.orderId,
                affiliation: 'Shop',
                revenue: parseInt(data.price, 10),
                shipping: 'monobrand_pickup',
              },
              products: [data.product],
            },
          },
        });
        break;
      case types.EVENT_SELECT_TRADE_IN: {
        dataLayer.push({
          event: 'calc_Bee',
          details: {
            flow: 'Калькулятор Trade-In',
            name: data.name,
          },
        });
        break;
      }
      case types.EVENT_PROMO_CLICK_BUTTON_BUY: {
        dataLayer.push({
          event: 'addToCart_EC',
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              actionField: { list: data.listHeading },
              products: [
                {
                  brand: data.brand,
                  category: data.category?.toLowerCase(),
                  id: data.productId,
                  name: data.title,
                  price: (data.price || {}).value,
                  metric14: data.discount,
                  metric15: null, // TODO: [SHOP-4015]
                  dimension15: null, // TODO: [SHOP-4015]
                  dimension16: null, // TODO: [SHOP-4015]
                  dimension17: null, // TODO: [SHOP-4015]
                  quantity: 1,
                },
              ],
            },
          },
        });
        break;
      }
      case types.EVENT_VOTE_FORM_WIDGET_VOTE: {
        const { question, answer } = data;
        dataLayer.push({
          event: 'vote_Bee',
          details: {
            question,
            answer,
          },
        });
        break;
      }
      case types.EVENT_VOTE_FORM_WIDGET_SUBSCRIBE: {
        const { question } = data;
        dataLayer.push({
          event: 'subscribe_Bee',
          details: {
            question,
          },
        });
        break;
      }
      case types.EVENT_BANNER_BLOCKS_BANNER_VIEW: {
        dataLayer.push({
          event: 'promoView_EC',
          ecommerce: {
            promoView: {
              promotions: [
                {
                  name: data.name,
                  creative: data.creative,
                  position: data.position,
                },
              ],
            },
          },
          details: {
            promoType: 'Кубик',
          },
        });
        break;
      }
      case types.EVENT_BANNER_BLOCKS_BANNER_CLICK: {
        dataLayer.push({
          event: 'promoClick_EC',
          ecommerce: {
            promoView: {
              promotions: [
                {
                  name: data.name,
                  creative: data.creative,
                  position: data.position,
                },
              ],
            },
          },
          details: {
            promoType: 'Кубик',
          },
        });
        break;
      }
      case types.EVENT_PROMO_CLICK_DETAILS: {
        dataLayer.push({
          event: 'productClick_EC',
          ecommerce: {
            click: {
              actionField: { list: data.listHeading },
              products: [
                {
                  brand: data.brand,
                  category: data.category?.toLowerCase(),
                  id: data.productId,
                  name: data.title,
                  price: (data.price || {}).value,
                  metric14: data.discount,
                  metric15: null, // TODO: [SHOP-4015]
                  dimension15: null, // TODO: [SHOP-4015]
                  dimension16: null, // TODO: [SHOP-4015]
                  dimension17: null, // TODO: [SHOP-4015]
                },
              ],
            },
          },
        });
        break;
      }
      case types.EVENT_PROMO_VIEW_SLIDER: {
        const { userRegionTitle, federalRegionName, slides, listHeading } = data;
        const viewSlides = (slides || []).map((item) => ({
          brand: item.brand,
          category: item.category?.toLowerCase(),
          id: item.productId,
          list: listHeading,
          name: item.title,
          price: (item.price || {}).value,
          metric14:
            (item.price || {}).oldValue ? item.price.oldValue - (item.price || {}).value : null,
          dimension16: '', // TODO: [SHOP-4015]
        }));

        dataLayer.push({
          event: 'upsale_EC',
          regionName: userRegionTitle,
          federalRegionName,
          ecommerce: {
            currencyCode: 'RUB',
            impressions: viewSlides,
          },
        });
        break;
      }
      case types.EVENT_PROMO_MOVE_SLIDER: {
        const { userRegionTitle, federalRegionName, slides } = data;
        const viewSlides = (slides || []).map((item) => ({
          brand: item.brand,
          category: item.category?.toLowerCase(),
          id: item.productId,
          list: item.listHeading,
          name: item.title,
          price: (item.price || {}).value,
          metric14:
            (item.price || {}).oldValue ? item.price.oldValue - (item.price || {}).value : null,
          dimension16: '', // TODO: [SHOP-4015]
        }));
        dataLayer.push({
          event: 'upsale_EC',
          regionName: userRegionTitle,
          federalRegionName,
          ecommerce: {
            currencyCode: 'RUB',
            impressions: viewSlides,
          },
        });
        break;
      }
      case types.EVENT_PROMO_VIEW_BANNERS: {
        if (data.markup) {
          dataLayer.push({
            event: 'view_carousel_banner',
            ecommerce: {
              promoView: {
                promotions: data.markup,
              },
            },
          });
        } else {
          dataLayer.push({
            event: 'promoView_EC',
            ecommerce: {
              promoView: {
                promotions: data,
              },
            },
            details: {
              promoType: 'Карусель',
            },
          });
        }
        break;
      }
      case types.EVENT_PROMO_CLICK_BANNER: {
        if (data.markup) {
          dataLayer.push({
            event: 'click_carousel_banner',
            ecommerce: {
              promoClick: {
                promotions: data.markup,
              },
            },
          });
        } else {
          dataLayer.push({
            event: 'promoClick_EC',
            ecommerce: {
              promoClick: {
                promotions: data,
              },
            },
            details: {
              promoType: 'Карусель',
            },
          });
        }
        break;
      }
      case types.EVENT_PRODUCT_DAY_VIEW: {
        const { regionName, federalRegionName, ...restparams } = data;
        dataLayer.push({
          event: 'productDay_EC',
          regionName,
          federalRegionName,
          ecommerce: {
            currencyCode: 'RUB',
            impressions: [restparams],
          },
        });
        break;
      }
      case types.EVENT_PRODUCT_DAY_CLICK: {
        const { regionName, federalRegionName, actionField, ...restparams } = data;

        dataLayer.push({
          event: 'productClick_EC',
          regionName,
          federalRegionName,
          ecommerce: {
            currencyCode: 'RUB',
            click: {
              actionField,
              products: [restparams],
            },
          },
        });
        break;
      }
      case types.EVENT_PRODUCT_ADD_TO_CART: {
        const { regionName, federalRegionName, actionField, ...restparams } = data;

        dataLayer.push({
          event: 'addToCart_EC',
          regionName,
          federalRegionName,
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              actionField,
              products: [restparams],
            },
          },
        });
        break;
      }
      case types.EVENT_SUBSCRIBE_SUCCESS: {
        dataLayer.push({
          event: 'subscribe_mailing_Bee',
        });
        break;
      }
      case types.EVENT_SUBSCRIBE_ERROR: {
        dataLayer.push({
          event: 'subscribe_mailing_error_Bee',
        });
        break;
      }
      case types.EVENT_CATALOG_POPUP_DETAILS_OPEN: {
        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        dataLayer.push({
          ecommerce: {
            currencyCode: 'RUB',
            detail: {
              actionField: { list: 'Catalog_pre' }, // 'detail' actions have an optional list property.
              products: [
                {
                  name: data.name,
                  id: data.article, // data.id,
                  price: data.price,
                  brand: data.brand,
                  variant: data.variant,
                  category: data?.category?.toLowerCase(),
                },
              ],
            },
          },
        });
        break;
      }
      case types.EVENT_CATALOG_PRODUCTS_SEEN: {
        dataLayer.push({
          ecommerce: null,
        }); // Clear the previous ecommerce object.
        let deviceColor = '-';
        let memory = '-';
        // eslint-disable-next-line
        data?.characteristics.forEach((char) => {
          if (char.name === 'Объем памяти' || char.label === 'Объем памяти') {
            memory = char.value;
          }
          if (char.name === 'Цвет' || char.label === 'Цвет') {
            deviceColor = char.value;
          }
        });

        const variant = `${deviceColor}_${memory}`;

        dataLayer.push({
          ecommerce: {
            currencyCode: 'RUB',
            impressions: [
              {
                name: data.title,
                id: data.article, // data.id,
                price: data?.price?.value,
                brand: data?.brandName,
                category: data?.collectionName?.toLowerCase(),
                variant,
                list: 'Catalog',
                position: data?.index,
              },
            ],
          },
        });
        break;
      }
      case types.EVENT_CATALOG_PRODUCT_DETAILS_OPEN: {
        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        dataLayer.push({
          ecommerce: {
            currencyCode: 'RUB',
            detail: {
              actionField: { list: 'Catalog' }, // 'detail' actions have an optional list property.
              products: [
                {
                  name: data?.name,
                  id: data?.article,
                  price: data?.price,
                  brand: data?.brand,
                  variant: data?.variant,
                  category: data?.category?.toLowerCase(),
                },
              ],
            },
          },
        });
        break;
      }
      case types.EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_TRADE_IN: {
        dataLayer.push({
          ecommerce: {
            currencyCode: 'RUB',
            detail: {
              actionField: { list: 'Catalog' }, // 'detail' actions have an optional list property.
              products: [
                {
                  id: 'trade in',
                  name: 'trade in',
                  brand: `trade in | ${data?.brand}`,
                  category: 'trade in',
                  price: data?.price,
                  variant: data?.name,
                },
              ],
            },
          },
        });
        break;
      }
      case types.EVENT_ADD_TO_CART_WITH_TRADE_IN: {
        dataLayer.push({
          ecommerce: {
            currencyCode: 'RUB',
            add: {
              products: [
                {
                  id: 'trade in',
                  name: 'trade in',
                  price: data?.price,
                  quantity: 1,
                  brand: `trade in | ${data?.brand}`,
                  category: 'trade in',
                  variant: data?.name,
                },
              ],
            },
          },
        });

        break;
      }
      default:
        return false;
    }
  } catch (e) {
    /**
     * throw Error without breaking the main thread
     */
    setTimeout(() => {
      console.warn(`An error occurred while trying to push '${type}' to GTM`);
      throw new Error(e);
    }, 0);
    return true;
  }

  if (!defined) {
    window.dataLayer = dataLayer;
  }

  return true;
}
